export enum MessengerEventType {
    userLogin = 'user-login',
    userSignup = 'user-signup',
}
